import React, { useEffect } from "react";

export default function CardDetailNavigator() {
  useEffect(() => {
    window.location.href = "https://inspiredgrow.in/";
  }, []);

  return null; // no need to render anything
}

